import { withDevToolsStub } from '@angular-architects/ngrx-toolkit';
import { IEnvironmentSettings } from '@dxp/core/models';
import { EnvironmentType, LogLevel } from '@dxp/core/types';
import { createEnvironmentSettings } from './environment.factory';

export const environment: IEnvironmentSettings = createEnvironmentSettings({
    storeWithDevTools: withDevToolsStub,
    production: false,
    logLevel: LogLevel.Information,
    environment: EnvironmentType.Sand,
    authority: 'https://auth-sand.telxl.net',
    apiBaseUrl: 'https://api-sand.telxl.net',
    odataBaseUrl: 'https://odata-sand.telxl.net',
    heartbeatInterval: 30,
    pollingInterval: 60,
    cacheLifeTime: 60,
    isLoggingEnabled: false,
    isCacheEnabled: true,
    inActivityTimeOut: 0,
    scope: 'gum bp.access openid profile email offline_access',
    buildNumber: '20260327.1',
});
